// CLASSES
import AppConfig from "@classes/AppConfig";
import Validator from "@classes/Validator";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	const {fields, validFields, company} = state;

	for (const name in validFields) {
		if (validFields[name] === false) {
			return false;
		}
	}

	if (fields.customer_email.length <= 0 || !Validator.validateEmail(fields.customer_email))
	{
		return false;
	}

	if (company) {
		return !!(
			fields.customer_firstname.length > 0
			&& Validator.validateOrgNum(fields.customer_social_security_number, true)
		);
	}

	return !!(
		fields.customer_firstname.length > 0 &&
		fields.customer_lastname.length > 0 &&
		Validator.validateSsn(fields.customer_social_security_number, false)
	);
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/Withdrawal/CustomerInformation.fulfillment.js